/**
 * Extracts marketing and analytics tracking parameters from a query string.
 *
 * @param {string} queryString - The URL query string (including leading ?).
 * @returns {Object} An object containing the extracted tracking parameters.
 */
export const extractTrackingData = (queryString) => {
    if (!queryString) return {};

    const urlParams = new URLSearchParams(queryString);
    const data = {};

    const TRACKABLE_PARAMS = [
        "affiliate",
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_id",
        "utm_term",
        "utm_content",
        "utm_source_platform",
        "utm_creative_format",
        "utm_marketing_tactic",
        "fbclid",
        "gclid",
        "gbraid",
        "wbraid",
        "dclid",
        "_gl",
        "_ga",
        "_gcl_au"
    ];

    TRACKABLE_PARAMS.forEach(param => {
        if (urlParams.has(param)) {
            data[param] = urlParams.get(param);
        }
    });

    // Handle wildcards for _ga_*
    for (const [key, value] of urlParams.entries()) {
        if (key.startsWith("_ga_")) {
            data[key] = value;
        }
    }

    return data;
};
